<template>
    <div class="FieldHelpWrap">
        <div class="FieldHelpWrap__input">
            <STextInput
                :name="name"
                :input-data="text"
                :namespace="fieldNamespace"
                :key="fieldNamespace"
            />
        </div>
        <div
            class="FieldHelpWrap__help"
            v-if="helpText"
        >
            <HelpModal
                v-if="helpText"
                :text="helpText"
                :title="helpTitle"
            />
        </div>
    </div>
</template>

<script>
import SubmissionBoilerplate from '@/views/Public/Field/Fields/SubmissionBoilerplate';
import STextInput from '@/views/Common/Input/STextInput';

export default {

    components: {
        STextInput,
    },
    mixins: [ SubmissionBoilerplate ],

    data() {
        return {
            text: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.submission && this.submission.text) {
                this.text = this.submission.text;
            } else if (this.population && this.population.text) {
                this.text = this.population.text;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                text: this.text
            };

            this.storeFieldData();
        }
    }
};
</script>
